const g = (n) => n.consumer_usage_instructions !== void 0, v = (n) => n.preparation_instructions !== void 0, y = (n) => [
  "consumer_usage_instructions",
  "consumer_storage_instructions",
  "compulsory_additive_label_information",
  "language"
].includes(n), I = (n) => [
  "preparation_instructions",
  "serving_suggestion",
  "language"
].includes(n), l = (n, e, i) => {
  const m = n.find(
    (s) => s.language === e && (g(s) && y(i) && s[i] || v(s) && I(i) && s[i])
  ) || n.find(
    (s) => s.language === "fi" && (g(s) && y(i) && s[i] || v(s) && I(i) && s[i])
  );
  if (m) {
    if (g(m) && y(i))
      return m[i];
    if (v(m) && I(i))
      return m[i];
  }
  return null;
}, E = (n, e) => B(n, e, "fi").some(
  (i) => i.condition
), B = (n, e, i) => {
  var m, s, $, b, C, x, F, K, O, P, U, h, w, A, L, N, S, j, k, q, z;
  return [
    {
      condition: !!l(
        n == null ? void 0 : n.consumer_instructions,
        i,
        "consumer_usage_instructions"
      ),
      title: e("instructions_usage"),
      content: l(
        n == null ? void 0 : n.consumer_instructions,
        i,
        "consumer_usage_instructions"
      )
    },
    {
      condition: !!l(
        n == null ? void 0 : n.preparation_instructions,
        i,
        "preparation_instructions"
      ),
      title: e("instructions_preparation"),
      content: l(
        n == null ? void 0 : n.preparation_instructions,
        i,
        "preparation_instructions"
      )
    },
    {
      condition: !!l(
        n == null ? void 0 : n.preparation_instructions,
        i,
        "serving_suggestion"
      ),
      title: e("instructions_serving"),
      content: l(
        n == null ? void 0 : n.preparation_instructions,
        i,
        "serving_suggestion"
      )
    },
    {
      condition: !!((m = n == null ? void 0 : n.product_yields[0]) != null && m.product_yield) && !!(($ = (s = n == null ? void 0 : n.product_yields[0]) == null ? void 0 : s.product_yield_uoms[0]) != null && $.value),
      title: e("instructions_product_yield"),
      content: (b = n == null ? void 0 : n.product_yields[0]) != null && b.product_yield ? `${Number.parseFloat(
        (C = n == null ? void 0 : n.product_yields[0]) == null ? void 0 : C.product_yield
      ).toFixed(
        0
      )} ${(F = (x = n == null ? void 0 : n.product_yields[0]) == null ? void 0 : x.product_yield_uoms[0]) == null ? void 0 : F.code.toLowerCase()}` : null
    },
    {
      condition: !!l(
        n == null ? void 0 : n.consumer_instructions,
        i,
        "consumer_storage_instructions"
      ),
      title: e("instructions_storage"),
      content: l(
        n == null ? void 0 : n.consumer_instructions,
        i,
        "consumer_storage_instructions"
      )
    },
    {
      condition: !!l(
        n == null ? void 0 : n.consumer_instructions,
        i,
        "compulsory_additive_label_information"
      ),
      title: e("instructions_compulsory_additives"),
      content: l(
        n == null ? void 0 : n.consumer_instructions,
        i,
        "compulsory_additive_label_information"
      )
    },
    {
      condition: !!((K = n == null ? void 0 : n.lifespans[0]) != null && K.opened_trade_item_life_span) && !!((P = (O = n == null ? void 0 : n.lifespans[0]) == null ? void 0 : O.opened_trade_item_life_span_uoms) != null && P.some(
        (_) => _.language === i && _.value
      )),
      title: e("instructions_opened_life_span"),
      content: `${(U = n == null ? void 0 : n.lifespans[0]) == null ? void 0 : U.opened_trade_item_life_span} ${((A = (w = (h = n == null ? void 0 : n.lifespans[0]) == null ? void 0 : h.opened_trade_item_life_span_uoms) == null ? void 0 : w.find(
        (_) => {
          var f;
          return _.language === i || !((f = n == null ? void 0 : n.lifespans[0]) != null && f.opened_trade_item_life_span_uoms.some(
            (o) => o.language === i && o.value
          )) && _.language === "fi";
        }
      )) == null ? void 0 : A.value) || ""}`
    },
    {
      condition: !!((L = n == null ? void 0 : n.lifespans[0]) != null && L.min_product_life_span_from_production) && !!((S = (N = n == null ? void 0 : n.lifespans[0]) == null ? void 0 : N.min_product_life_span_from_production_uoms) != null && S.some(
        (_) => _.language === i && _.value
      )),
      title: e("instructions_production_life_span"),
      content: `${(j = n == null ? void 0 : n.lifespans[0]) == null ? void 0 : j.min_product_life_span_from_production} ${((z = (q = (k = n == null ? void 0 : n.lifespans[0]) == null ? void 0 : k.min_product_life_span_from_production_uoms) == null ? void 0 : q.find(
        (_) => {
          var f;
          return _.language === i || !((f = n == null ? void 0 : n.lifespans[0]) != null && f.min_product_life_span_from_production_uoms.some(
            (o) => o.language === i && o.value
          )) && _.language === "fi";
        }
      )) == null ? void 0 : z.value) || ""}`
    }
  ];
};
export {
  B as getInstructionSections,
  E as hasAnyInstructions
};
